// Kleine Bruecke zwischen fetchWithAuth (kein React-Kontext) und AuthContext.
// AuthContext registriert sich einmal als Handler; fetchWithAuth ruft ihn bei
// 401 / fehlendem Token auf. So gibt es nur noch EINEN Ort, der eine
// abgelaufene Session tatsaechlich beendet (State + Redirect + Toast).
let logoutHandler = null;

export function setLogoutHandler(fn) {
  logoutHandler = fn;
}

export function triggerSessionExpired() {
  logoutHandler?.();
}
